export enum CallContactEventStatus {
  MASKING = 'Masking',
  HOLDING = 'Holding',
  ACTIVE = 'Active',
  DISCONNECTED = 'Disconnected',
  DIALING = 'Dialing',
  INCOMING = 'Incoming',
  JOINED = 'Joined',
}
